import { render, staticRenderFns } from "./GoogleSsoSignUp.vue?vue&type=template&id=3c2c32d0"
import script from "./GoogleSsoSignUp.vue?vue&type=script&lang=js"
export * from "./GoogleSsoSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports